module.exports = __webpack_public_path__ + "img/beer_id-78.55e31dbc.png";